import { createFileRoute } from '@tanstack/react-router';
import { OperatorSecurityPage } from '@/features/operator/security-page';

export const Route = createFileRoute('/operator/security')({
    staticData: {
        crumbs: [{ label: 'shell.operatorConsole', to: '/operator' }, { label: 'operator.nav.security' }],
    },
    component: OperatorSecurityPage,
});
